export function UnreadDivider() {
  return (
    <div className="flex items-center gap-3 py-2">
      <span className="h-px flex-1 bg-brand-accent/40" />
      <span className="text-[11px] font-semibold text-brand-accent">New messages</span>
      <span className="h-px flex-1 bg-brand-accent/40" />
    </div>
  )
}
